var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shops)?_c('div',[_c('router-view')],1):_c('div',[_c('no-shop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }